export const CcmiLabsLocation = () => {
  return (
    <>
      
      <div className="labs-header">
        <img src="assets/img/labs-logo.png" alt="" />
        <p>21329 Nordhoff St. Chatsworth, CA 91311</p>
      </div>
    
      <div>
        <iframe
          width="100%"
          height="650"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
          src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=21329 Nordhoff St. Chatsworth, CA 91311+(Your%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        >
          <a href="https://www.gps.ie/sport-gps/">swimming watch</a>
        </iframe>
      </div>
    </>
  );
};
